var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"dark-container"},[_c('div',{staticClass:"rodeo-name"},[_vm._v(_vm._s(_vm.rally.name)+" "+_vm._s(_vm.rallyRound.name))]),_c('commit-chart',{attrs:{"chartData":{
    labels: ['Bezahlt & Fertig', 'Angemeldet', 'Frei', 'Warteliste'],
    datasets: [
      {
        label: 'Anmeldungen',
        backgroundColor: ['#0D9F3D', '#76B82E', '#AFCA12'],
        data: [_vm.sumPaidAndFinished, _vm.sumRegistered, _vm.sumAvailable],
      }
    ]
  }}}),_c('div',{staticClass:"description"},[_vm._v(" Limit= "),_c('div',{staticClass:"right"},[_vm._v(_vm._s(_vm.sumMax))]),_c('br'),_vm._v(" Angemeldet="),_c('div',{staticClass:"right"},[_vm._v(_vm._s(_vm.sumRegistered))]),_c('br'),_vm._v(" Bezahlt & Fertig="),_c('div',{staticClass:"right"},[_vm._v(_vm._s(_vm.sumPaidAndFinished))]),_c('br'),_vm._v(" Frei="),_c('div',{staticClass:"right"},[_vm._v(_vm._s(_vm.sumAvailable))]),_c('br'),_vm._v(" Warteliste="),_c('div',{staticClass:"right"},[_vm._v(_vm._s(_vm.sumWaitlist))]),_c('br')])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }